/* eslint-disable monorepo/no-internal-import */
import {parseRequestProperties} from '@aboutyou/bootstrap/src/parseRequestProperties';
import {Environment, shopConfigByLocale} from '@aboutyou/config';
import {sendServerLogToDatadog} from '@aboutyou/mlm';
import type {Request} from 'express';

type PoaProxyStatusOptions = {
  is_api_proxy: boolean;
  status_code: number;
  error?: string;
  details?: string;
};

export const logPoaProxyStatus = ({
  req,
  environment,
  attributes,
}: {
  req: Request;
  environment: Environment;
  attributes: PoaProxyStatusOptions;
}): void => {
  try {
    const {isAppLinksSubdomainRequest, locale, hostname} =
      parseRequestProperties({req});

    const device = isAppLinksSubdomainRequest
      ? 'app'
      : `${process.env.STACK}-web`;

    sendServerLogToDatadog({
      message: 'poa-proxy-status',
      hostname,
      environment,
      status: attributes.error !== undefined ? 'error' : 'info',
      attributes: {
        feat: 'bnpl',
        event: 'poa-proxy-status',
        path: req.originalUrl.split('?')?.[0],
        ...attributes,
        meta_data: {
          shop_id: locale ? shopConfigByLocale[locale]?.shopId : undefined,
          locale,
          device,
        },
      },
    });
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('logPoaProxyStatus failed:', err);
    }
  }
};
